import React, { FunctionComponent, useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "../ui/drawer";
import { Button } from "../ui/button";
import { Info } from "lucide-react";
import Image from "next/image";
import BlockContent from "../blocks/BlockContent";
import { cn } from "../../lib/utils";
import { useMediaQuery } from "../../hooks/use-media-query";

interface InfoModalProps {
  option: any;
  className?: string;
}

const InfoModal: FunctionComponent<InfoModalProps> = (props) => {
  const { option, className } = props;
  const content = option?.metadata?.moreInfo;
  const [open, setOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (!content) return null;

  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="icon"
            variant="secondary"
            className={cn(
              "rounded-full w-6 h-6 bg-white/80 backdrop-blur-sm hover:bg-white",
              className
            )}
            onClick={handleInfoClick}
          >
            <Info className="w-4 h-4 text-gray-600 stroke-[1.5px]" />
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-2xl w-full py-6 overflow-y-auto max-h-screen lg:max-h-[90svh]">
          <DialogHeader className="hidden">
            <DialogTitle>{option?.code}</DialogTitle>
          </DialogHeader>
          <BlockContent blocks={content} />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          size="icon"
          variant="secondary"
          className={cn(
            "rounded-full w-6 h-6 bg-white/80 backdrop-blur-sm hover:bg-white",
            className
          )}
          onClick={handleInfoClick}
        >
          <Info className="w-4 h-4 text-gray-600 stroke-[1.5px]" />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className="hidden">
          <DrawerTitle>{option?.code}</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 py-6 overflow-y-auto max-h-[80svh]">
          <BlockContent blocks={content} />
        </div>
        <DrawerFooter className="pt-2">
          <DrawerClose asChild>
            <Button variant="outline">Close</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default InfoModal;
